import { render, staticRenderFns } from "./comp_BookPreviewBallsLoader.vue?vue&type=template&id=774af434&"
import script from "./comp_BookPreviewBallsLoader.vue?vue&type=script&lang=js&"
export * from "./comp_BookPreviewBallsLoader.vue?vue&type=script&lang=js&"
import style0 from "./comp_BookPreviewBallsLoader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports